/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Correct_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to auto correct events based on reading rate" |
*
* @param {Auto_Correct_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_correct_failed = /** @type {((inputs?: Auto_Correct_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Correct_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la correction automatique des événements selon la vitesse de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die automatische Korrektur von Ereignissen basierend auf der Lesegeschwindigkeit ist fehlgeschlagen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile correggere automaticamente gli eventi in base alla velocità di lettura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось автоматически скорректировать события на основе скорости чтения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron corregir automáticamente los eventos según la velocidad de lectura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根据阅读速率自动更正事件失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読み取り速度に基づいてイベントを自動修正できませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पठन दर के आधार पर घटनाओं को स्वतः ठीक करने में विफलता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha na correção automática de eventos com base na taxa de leitura.")
	return /** @type {LocalizedString} */ ("Failed to auto correct events based on reading rate")
});